import { AccountDrawerConfiguration, CustomerSource } from 'shared-types'

export enum AuthenticationDrawersTypes {
  Login = 'login',
  Register = 'register',
  ForgotPassword = 'forgot-password',
  ResetPassword = 'reset-password',
  MigrateOnlineAccount = 'migrate-online-account',
  MigrateStoreAccount = 'migrate-store-account',
}

export interface SignUpAuthenticationFormProps {
  setIsSignedUpSuccessfull: React.Dispatch<boolean>
}

export interface AuthenticationDrawerContentProps {
  onClose: (isRedirect?: boolean) => void
  enabledPaymentMethods?: string[]
  accountDrawerConfiguration?: AccountDrawerConfiguration
}

export interface AccountMigrationDrawerProps {
  onClose: (isRedirect?: boolean) => void
  customerSource: CustomerSource
}

export type ForgotPasswordFormData = {
  email: string
}
